// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5106":"976aae30","5321":"976aae30","7460":"77ab36e7","9807":"976aae30"}[chunkId] + ".chunk.css";
};